export default __webpack_public_path__ + "static/media/01__o_5.ed93ee1d.jpg";